export default "__VITE_ASSET__B6z2DJKK__"